import { useParams } from 'react-router-dom';
import { useState,useEffect } from 'react';

import { AttendeeAndPresenterProvider } from '../context/AttendeeAndPresenterProvider';
import { validateMeetingId } from '../../utils/validateMeetingID';

import GameComponent from './GameComponent';
import LoadingComponent from '../common/LoadingComponent';

const BipolarGameComponent = () => {
  const { meetingId } = useParams();
  const [loaded, setLoaded] = useState(false);


  useEffect(() => {

    if (meetingId) {
      validateMeetingId(meetingId).then(()=> setLoaded(true));
    }
  }, [meetingId]);

  if(!loaded){
    return <LoadingComponent/>
  }

  return (
    <AttendeeAndPresenterProvider meetingId={meetingId}>
      <GameComponent />
    </AttendeeAndPresenterProvider>
  );
};

export default BipolarGameComponent;
